import CCalendar from "./calendar.vue";
export default CCalendar;
export type CCalendarInstance = InstanceType<typeof CCalendar>;
